import { Link } from 'react-router-dom'

export function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white mt-16">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3
              className="text-xl mb-3"
              style={{ fontFamily: "Canela, Georgia, serif" }}
            >
              Purpose Collective
            </h3>
            <p
              className="text-gray-400 text-sm leading-relaxed max-w-xs"
              style={{ fontFamily: "'GT America Trial Regular', -apple-system, sans-serif" }}
            >
              Instead of infinite choice, we help you make the better choice.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4
              className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4"
              style={{ fontFamily: "'GT America Mono', 'Courier New', monospace" }}
            >
              Links
            </h4>
            <ul className="space-y-2 text-sm" style={{ fontFamily: "'GT America Trial Regular', -apple-system, sans-serif" }}>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About
                </Link>
              </li>
              <li>
                <a href="https://www.purposecollective.world/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Editorial
                </a>
              </li>
              <li>
                <a href="mailto:hello@purposecollective.world" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <Link to="/support" className="text-gray-300 hover:text-white transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Social + Legal */}
          <div>
            <h4
              className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4"
              style={{ fontFamily: "'GT America Mono', 'Courier New', monospace" }}
            >
              Connect
            </h4>
            <ul className="space-y-2 text-sm" style={{ fontFamily: "'GT America Trial Regular', -apple-system, sans-serif" }}>
              <li>
                <a href="https://www.instagram.com/purposecollectiveworld/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/purpose-collective-world/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-gray-500 text-xs"
            style={{ fontFamily: "'GT America Mono', 'Courier New', monospace" }}
          >
            &copy; {new Date().getFullYear()} Purpose Collective World. All rights reserved.
          </p>
          <div className="flex gap-6 text-xs" style={{ fontFamily: "'GT America Mono', 'Courier New', monospace" }}>
            <Link to="/terms" className="text-gray-500 hover:text-gray-300 transition-colors">
              Terms of Service
            </Link>
            <Link to="/privacy" className="text-gray-500 hover:text-gray-300 transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
